/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortform_Replacement_TableInputs */



/**
* | output |
* | --- |
* | "Shortform Replacement Table" |
*
* @param {Shortform_Replacement_TableInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortform_replacement_table = /** @type {((inputs?: Shortform_Replacement_TableInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortform_Replacement_TableInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Table des remplacements d'abréviations")
	if (locale === "de") return /** @type {LocalizedString} */ ("Kurzform-Ersatztabelle")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tabella di sostituzione abbreviata")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Таблица замены кратких форм")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tabla de reemplazo de formato corto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("简式替换表")
	if (locale === "ja") return /** @type {LocalizedString} */ ("短縮形置換表")
	if (locale === "hi") return /** @type {LocalizedString} */ ("संक्षिप्त प्रतिस्थापन तालिका")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tabela de Substituição de Formato Abreviado")
	return /** @type {LocalizedString} */ ("Shortform Replacement Table")
});